let allEnv = {
  test: './test',
  production: './prod',
  development: './dev',
  uat: './uat'
}
let env = allEnv[process.env.NODE_ENV]
let config = require(`${env}`).default
export default config



// WEBPACK FOOTER //
// ./src/config/index.js